<template>
    <div>
        <div class="row mb-5 news-filters">
            <div class="col-md-6 col-lg-4 news-filters__cat">
                <div v-if="!_.isEmpty(categories)" class="form-group bmd-form-group is-filled form-group--arrow">
                    <label for="newscat" class="bmd-label-floating">Filter by Category</label>
                    <select v-model="currentCat" class="form-control form-control--select" id="newscat" name="newscat">
                        <option :value="null">Please select one</option>
                        <option v-for="cat in categories" :value="cat.id">{{ cat.name }}</option>
                    </select>
                </div>
                <!-- <ul class="nav mt-3" role="tablist">
                    <li class=""><a v-on:click="filterByCat(null)" href="javascript:void(0)" role="tab" data-toggle="tab">All</a></li>
                    <li v-for="cat in categories" class="">
                        <a v-on:click="filterByCat(cat)" href="#cat-2" role="tab" data-toggle="tab">{{ cat.name }}</a>
                    </li>
                </ul> -->
            </div>
            <div class="col-md-6 col-lg-4 news-filters__date offset-lg-4">
                <div class="form-group bmd-form-group is-filled form-group--arrow">
                    <label for="itemselect" class="bmd-label-floating">Filter by Date</label>
                    <select v-model="currentDate" class="form-control form-control--select" id="itemselect" name="referrals">
                        <option :value="null">View all</option>
                        <option v-for="date in dateList" :value="date">{{ date.text }}</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="row news-filters__cards" id="lazyload-items">
            <div v-for="post in filteredList" class="col-sm-6 col-md-4 lazyload-item mh-item" data-mh="mh-item">
                <a :href="getPostLink(post)" class="news-filters__cards__item card">

                    <div class="news-filters__cards__header card-header card-btn " :style="'background-image:url(' + _.imgPath(post.image, 'w600_c600x400_q95') + ');'">
                    </div>
                    <div class="news-filters__cards__body card-body">
                        <h5>{{ post.name }}</h5>
                        <!-- <p v-if="post.category" class="news-cat">Posted in: <span>{{ post.category.name }}</span></p> -->
                        <p>{{ post.date }}</p>
                        <p>{{ post.intro }}</p>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>
<script>
import M from 'moment';
import UtilsMixin from './UtilsMixin';
import SelectBoxComponent from './form/SelectBoxComponent';

export default {
    data() {
        return {
            currentCat: null,
            currentDate: null,
        }
    },

    mounted() {

    },

    props: ['initialData'],

    components: {
        SelectBoxComponent,
    },

    mixins: [UtilsMixin],

    watch: {

    },

    computed: {
        filteredList() {
            return _.chain(this.initialData)
                .get('posts')
                .map(p => ({ ...p,
                    category: this.getNewsCategory(p),
                    timestamp: this.createDate(p.available_at || p.created_at).unix(),
                    date: this.createDate(p.available_at || p.created_at).format('DD MMM YYYY'),
                }))
                .sortBy('timestamp')
                .reverse()
                .filter(p => {
                    let pass = true;
                    if (pass && this.currentCat) {
                        pass = p.news_category_id === this.currentCat;
                    }

                    if (pass && this.currentDate) {
                        const date = this.createDate(p.available_at || p.created_at).format('YYYY-MM-DD');
                        pass = (date <= this.currentDate.max) && (date >= this.currentDate.min);
                    }

                    return pass;
                })
                .value();
        },

        categories() {
            return _.chain(this.initialData)
                .get('posts')
                .map(this.getNewsCategory)
                .filter()
                .sortBy('position')
                .uniqBy('id')
                .value();
        },

        dateList() {
            return _.chain(this.initialData)
                .get('posts')
                .map(p => p.available_at || p.created_at)
                .map(dt => {
                    const date = this.createDate(dt);

                    return {
                        value: date.format('YYYY-MM'),
                        text: date.format('MMMM YYYY'),
                        min: date.format('YYYY-MM-DD'),
                        max: date.add(1, 'month').format('YYYY-MM-DD'),
                    }
                })
                .uniqBy('value')
                .value();
        }
    },

    methods: {
        getNewsCategory(post) {
            return _.chain(this.initialData)
                .get('categories', [])
                .find(cat => cat.id == post.news_category_id)
                .value();
        },

        filterByDate(date) {
            this.currentDate = date;
        },

        filterByCat(cat) {
            this.currentCat = cat;
        },

        createDate(date) {
            return M(date, 'YYYY-MM-DD hh:mm:ss');
        },

        getPostLink(post) {
            return window.location.pathname + '/' + post.name_id;
        },
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/site/js/components/NewsListComponent.vue